import React, { Fragment, useState } from "react";
import { AppStrings, AppStringsByLang } from "../terms/appTerms";
import { Alert, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, FormGroup, FormLabel, IconButton, List, ListItem, ListItemText, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material";
import { CalculationResult, DegreeType, Faculty, Lang, MiluimPeriod } from "../types/general";
import Moment from "moment";
import { DatePicker } from "@mui/x-date-pickers";
import { Cancel, Clear, Delete, DeleteOutline } from "@mui/icons-material";
import { calcRights, getFaculty } from "../utils/appUtils";
import CalcResult from "./CalcResult";
import { extendMoment } from 'moment-range';
import { WAR_START_DATE } from "../utils/config";
const moment = extendMoment(Moment as any);

function Calculator(props: { lang: Lang }) {

    const Strings = AppStringsByLang(props.lang);
    const faculty = getFaculty();
    const [isStudent, setIsStdudent] = useState<boolean>();
    const [degreeType, setDegreeType] = useState<DegreeType>();
    const [periods, setPeriods] = useState<MiluimPeriod[]>();
    const [newPeriodFrom, setNewPeriodFrom] = useState<string | null>(null);
    const [newPeriodTo, setNewPeriodTo] = useState<string | null>(null);
    const [calcResult, setCalcResult] = useState<CalculationResult[]>();
    const [isCalculating, setIsCalculating] = useState(false);
    const [isShowError, setIsShowError] = useState(false);

    const getPeriodDates = (period: MiluimPeriod, index: number, arr: MiluimPeriod[]) => {
        return <Typography variant="body1">
            {(arr.length > 1 ? (index + 1) + ") " : "") + Strings.from + ": "}
            <strong>{moment(period.from, "DD/MM/YYYY").format("DD/MM/YYYY")}</strong>
            &nbsp;&nbsp;&nbsp;
            {Strings.to + ": "}
            <strong>{moment(period.to, "DD/MM/YYYY").format("DD/MM/YYYY")}</strong>
        </Typography>

    }

    const addPeriod = () => {
        if (newPeriodFrom && newPeriodTo) {
            const range1 = moment.range(moment(newPeriodFrom, "DD/MM/YYYY"), moment(newPeriodTo, "DD/MM/YYYY"));
            if (range1.diff("days") + 1 < 0) {
                setIsShowError(true);
                return;
            }
            if (periods && periods.find(p => {
                const range2 = moment.range(moment(p.from, "DD/MM/YYYY"), moment(p.to, "DD/MM/YYYY"));
                return range1.overlaps(range2, { adjacent: true });
            })) {
                setIsShowError(true);
                return;
            }

            setIsShowError(false);
            setPeriods([...(periods || []), { from: newPeriodFrom, to: newPeriodTo }]);
            setNewPeriodFrom(null);
            setNewPeriodTo(null);
        }
    }

    const deletePeriod = (period: MiluimPeriod) => () => {
        if (periods) {
            setPeriods(periods.filter(p => p.from !== period.from || p.to !== period.to));
        }
    }
    const getDiff = (period: MiluimPeriod) => {
        const start = moment(period.from, "DD/MM/YYYY");
        const end = moment(period.to, "DD/MM/YYYY");
        const range = moment.range(start, end);
        return range.diff("days") + 1 + " " + Strings.days;
    }

    const calc = () => {
        setIsCalculating(true);
        setTimeout(() => {
            if (degreeType !== undefined && isStudent !== undefined && periods !== undefined) {
                const res = calcRights(!!isStudent, degreeType, periods);
                setCalcResult(res);
            }
            setIsCalculating(false);
        }, 500);

    }

    const isDisabled = () => {
        return degreeType === undefined || isStudent === undefined || periods === undefined || periods.length === 0;
    }

    const clear = () => {
        setIsStdudent(undefined);
        setDegreeType(undefined);
        setNewPeriodFrom(null);
        setNewPeriodTo(null);
        setPeriods(undefined);
        setCalcResult(undefined);
        setIsCalculating(false);
        setIsShowError(false);
    }

    return (
        <FormControl>
            {/* <FormLabel id="radio-buttons-group-label" >
                <Typography variant="subtitle1">
                    {Strings.pleaseFill}
                </Typography>
            </FormLabel> */}
            <RadioGroup
                aria-labelledby="radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                value={isStudent !== undefined ? isStudent : null}
                onChange={(e) => { setIsStdudent(e.target.value === "student") }}
            >
                <FormControlLabel value="student" control={<Radio size="small" checked={isStudent} />} label={<Typography variant="h6" component="p">
                    {Strings.studentInMiluim}
                    <Typography color="GrayText" variant="body2">{Strings.orFinishedMiluim}</Typography>
                </Typography>} />
                <FormControlLabel value="studentMate" control={<Radio size="small" checked={isStudent === false} />} label={<Typography variant="h6" component="p" sx={{ mt: "16px" }}>
                    {Strings.mateOfMiluim}
                    <Typography color="GrayText" variant="body2">{Strings.OnlyWithChildren}</Typography>
                </Typography>} />

            </RadioGroup>
            <FormLabel id="radio-buttons-group-label" sx={{ mt: "24px", mb: "12px" }}>
                <Typography variant="h6" color="black" fontWeight="bold">
                    {Strings.degreeType}
                </Typography>
            </FormLabel>
            {faculty !== Faculty.DENTAL && faculty !== Faculty.BSCHOOL && <Select size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={degreeType !== undefined ? degreeType : null}
                // label={Strings.degreeType}
                onChange={(e) => { setDegreeType(e.target.value as DegreeType); }}
            >
                <MenuItem value={DegreeType.Boger}>{Strings.Boger}</MenuItem>
                <MenuItem value={DegreeType.Musmach}>{Strings.Musmach}</MenuItem>
                <MenuItem value={DegreeType.RefuaChishuvit}>
                    {faculty === Faculty.CSE ? Strings.RefuaChishuvit : Strings.DoubleDegree}
                </MenuItem>
            </Select>}
            <Typography>{degreeType === DegreeType.RefuaChishuvit ? Strings.DoubleDegreeMalagComment : ''}</Typography>
            {/* Dental select */}
            {faculty === Faculty.DENTAL && <Select size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={degreeType !== undefined ? degreeType : null}
                // label={Strings.degreeType}
                onChange={(e) => { setDegreeType(e.target.value as DegreeType); }}
            >
                <MenuItem value={DegreeType.DentalBogerShanaA}>{Strings.DentalBogerShanaA}</MenuItem>
                <MenuItem value={DegreeType.DentalBogerShanaB}>{Strings.DentalBogerShanaB}</MenuItem>
                <MenuItem value={DegreeType.DentalBogerShanaC}>{Strings.DentalBogerShanaC}</MenuItem>
                <MenuItem value={DegreeType.DentalDoctorShanaD}>{Strings.DentalDoctorShanaD}</MenuItem>
                <MenuItem value={DegreeType.DentalDoctorShanaE}>{Strings.DentalDoctorShanaE}</MenuItem>
                <MenuItem value={DegreeType.DentalDoctorShanaF}>{Strings.DentalDoctorShanaF}</MenuItem>
                <MenuItem value={DegreeType.DentalMusmach}>{Strings.DentalMusmach}</MenuItem>
            </Select>}
            {faculty === Faculty.BSCHOOL && <Select size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={degreeType !== undefined ? degreeType : null}
                // label={Strings.degreeType}
                onChange={(e) => { setDegreeType(e.target.value as DegreeType); }}
            >
                <MenuItem value={DegreeType.Boger}>{Strings.Boger}</MenuItem>
                <MenuItem value={DegreeType.BschoolMusmach}>{Strings.Musmach}</MenuItem>
                <MenuItem value={DegreeType.BschoolMaslulMuatz}>{Strings.BschoolMaslulMuatz}</MenuItem>
            </Select>}
            <FormLabel id="radio-buttons-group-label" sx={{ mt: "24px", mb: "16px" }}>
                <Typography variant="h6" color="black" fontWeight="bold">
                    {Strings.miluimPeriods}
                </Typography>
            </FormLabel>
            <Box sx={{ display: "grid", gridTemplateColumns: "3fr 3fr auto" }}>
                <DatePicker label={Strings.from} format="DD/MM/YYYY"
                    value={newPeriodFrom ? moment(newPeriodFrom, "DD/MM/YYYY") : null}
                    onChange={val => { setNewPeriodFrom(val?.format("DD/MM/YYYY") || null) }}
                    sx={{ mr: "16px" }}
                    minDate={moment("07/10/2023", "DD/MM/YYYY")}
                    slotProps={{
                        textField: { size: 'small' },
                        nextIconButton: { sx: { transform: props.lang === Lang.he ? "rotate(180deg)" : "" } },
                        previousIconButton: { sx: { transform: props.lang === Lang.he ? "rotate(180deg)" : "" } },
                    }}

                />
                <DatePicker label={Strings.to}
                    format="DD/MM/YYYY"
                    value={newPeriodTo ? moment(newPeriodTo, "DD/MM/YYYY") : null}
                    onChange={val => { setNewPeriodTo(val?.format("DD/MM/YYYY") || null) }}
                    sx={{ mr: "16px" }}
                    minDate={moment("07/10/2023", "DD/MM/YYYY")}
                    slotProps={{
                        textField: { size: 'small' },
                        nextIconButton: { sx: { transform: props.lang === Lang.he ? "rotate(180deg)" : "" } },
                        previousIconButton: { sx: { transform: props.lang === Lang.he ? "rotate(180deg)" : "" } },
                    }} />
                <div style={{ color: 'rgb(0,147,149)' }}>
                    <Button variant="outlined" color="inherit"
                        onClick={addPeriod}
                        sx={{ height: "100%" }}>{Strings.add}</Button>
                </div>
            </Box>
            {isShowError && <Alert severity="error" onClose={() => { setIsShowError(false) }} sx={{ mt: "16px" }}>
                {Strings.datesOverlapping}
            </Alert>}
            {periods && <FormLabel id="radio-buttons-group-label" sx={{ mt: "24px", }}>
                <Typography variant="subtitle1" >
                    {Strings.periods}
                </Typography>
            </FormLabel>}
            {periods && <List disablePadding>
                {periods.map((period, index, arr) => <ListItem divider={arr.length > 1}
                    disablePadding
                    sx={{ py: "8px" }}
                    secondaryAction={
                        <IconButton edge="end" aria-label="comments" onClick={deletePeriod(period)}>
                            <DeleteOutline color="error" />
                        </IconButton>
                    }>
                    <ListItemText primary={getPeriodDates(period, index, arr)}
                        secondary={getDiff(period)}
                        secondaryTypographyProps={{ px: arr.length > 1 ? "18px" : "" }} />
                </ListItem>)}
            </List>}
            <Box sx={{ display: "flex", justifyContent: "center", mt: "24px", mb: "24px", color: "#763160", }}>

                <Button color="inherit" variant="contained"
                    size="large"
                    disabled={isDisabled()}
                    onClick={calc}
                    sx={{ background: "#763160", color: "white", "&:hover": { backgroundColor: "#9d5485" } }}>
                    {Strings.calc}
                </Button>
                <Button color="info" variant="outlined"
                    size="large"
                    onClick={clear}
                    sx={{ ml: "16px", color: "#4e4e4e", border: "1px solid #9a9a9a", "&:hover": { border: "1px solid #9a9a9a" } }}
                >
                    {Strings.clear}
                </Button>
            </Box>
            {calcResult && !isCalculating && <CalcResult result={calcResult} lang={props.lang} />}
            {isCalculating && <Box sx={{ display: "flex", justifyContent: "center", my: "16px" }}>
                <CircularProgress color="secondary" />
            </Box>}
        </FormControl>
    );
}
export default Calculator;
